// Auto-generated client configuration - DO NOT EDIT MANUALLY
// Generated during Docker build from clients/{CLIENT_ID}/config.json
// This file is replaced at build time with client-specific configuration

export const CLIENT_CONFIG = 
{
  "client_id": "ahv",
  "features": {
    "internet_search": false,
    "gpt_search": false,
    "internal_search": true,
    "agents": false
  },
  "integrations": {
    "azure_search": {
      "enabled": true,
      "index_prefix": "ahv"
    },
    "sharepoint": {
      "enabled": false,
      "site_urls": []
    }
  },
  "theme": {
    "name": "AHV",
    "colors": {
      "primary": "#2e9445",
      "secondary": "#5a9359",
      "accent": "#2e9445",
      "background": "#FFFFFF",
      "surface": "#FEF2F2",
      "text": {
        "primary": "#1F2937",
        "secondary": "#6B7280",
        "muted": "#9CA3AF"
      },
      "success": "#059669",
      "warning": "#D97706",
      "error": "#DC2626"
    },
    "branding": {
      "logoUrl": "/assets/ahv/logo.png",
      "faviconUrl": "/assets/ahv/favicon.ico",
      "agentIconUrl": "/assets/ahv/AVA-Avatar-AHV.png",
      "internalIconUrl": "/assets/ahv/internalIcon.png",
      "companyName": "AHV",
      "tagline": "AHV AI Assistant",
      "supportEmail": "support@ahv.com",
      "backgroundImage": ""
    },
    "typography": {
      "fontFamily": "'ABSIDE REGULAR', Roboto, system-ui, sans-serif",
      "headingFontFamily": "'ABSIDE REGULAR', Roboto, system-ui, sans-serif"
    },
    "layout": {
      "sidebarWidth": "300px",
      "headerHeight": "72px",
      "borderRadius": "6px"
    },
    "customTexts": {
      "welcomeMessage": "Welcome to the AHV AI Platform",
      "chatPlaceholder": "Ask AHV AI anything...",
      "footerText": "© AHV - Animal Health Vision",
      "fallbackAgentDescription": "AI assistant for company knowledge from AHV International."
    }
  }
}
;

export const CLIENT_ID = CLIENT_CONFIG.client_id;

export const IS_DEVELOPMENT = false;
